<template>
	<div class="row filter-nav align-center">
		<div>
			<div>
				<span
					class="filter-button"
					:class="{ active: filter === 'showAll' }"
					@click="$emit('change-filter', 'showAll')"
					>{{ $t('showAll') }}</span
				>
			</div>
			<div v-for="item in items" :key="item.ID">
				<span
					class="filter-button"
					:class="{ active: filter === item.name }"
					@click="$emit('change-filter', item.name)"
					>{{ item.name }}</span
				>
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});

defineEmits(['change-filter']);
</script>

<style lang="scss" scoped>
.filter-nav > div > div {
	border-right: 1px solid var(--body-color);

	&:last-child {
		border: none;
	}
}

.filter-button {
	margin: 0 8px;
}

.filter-nav {
	margin: 0 auto;
	width: 100%;
	display: flex;
	place-content: center center;

	> div {
		display: flex;
		flex-flow: row wrap;
		place-content: center center;

		div {
			margin: 5px 0;
		}
	}

	span {
		padding: 0 2px;
		margin: 0 12px;
		cursor: pointer;
		display: inline-block;
		text-transform: uppercase;
		transition: all 0.3s ease-in-out;
		color: var(--body-color);
		border-bottom: 2px solid rgb(0 0 0 / 0%);
		text-decoration: none;
		font-weight: 700;
		letter-spacing: 1px;
		font-size: var(--body-font-size);

		&.active {
			border-color: var(--body-color);
			color: var(--body-color);
		}
	}
}

@media (max-width: 1080px) {
	.filter-nav {
		margin: 0 auto 20px;

		> div {
			text-align: center;
		}
	}
}
</style>
